module.exports = __webpack_public_path__ + "static/16-bc25fc959e524269985a1385e316b41c.png";